import { AfterViewInit, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { VSelectComponent } from "../v-select.component";
import "./v-select-option.component.scss";

@Component({
    selector: "v-select-option",
    template: require("./v-select-option.component.html")
})
export class VSelectOptionComponent implements OnInit, OnDestroy {
    @Input() label: string;
    @Input() value: string;
    @Input() icon: string;
    @Input() selected = false;

    constructor(private readonly parent: VSelectComponent) {
    }

    ngOnInit(): void {
        this.parent.registerSelectOption(this);
    }

    ngOnDestroy(): void {
        this.parent.deregisterSelectOption(this);
    }

    // ---

}
